import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'tech-loading-screen-dialog',
  templateUrl: './loading-screen-dialog.component.html',
  styleUrls: ['./loading-screen-dialog.component.scss'],
})
export class LoadingScreenDialogComponent implements OnInit, OnDestroy {
  private timer: any;

  textLoading: boolean = false;

  ngOnInit(): void {
    this.timer = setTimeout(() => {
      this.textLoading = true;
    }, 20000);
  }

  ngOnDestroy(): void {
    clearTimeout(this.timer);
  }
}
